import React from 'react';
import {View} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import Svg, {Circle} from 'react-native-svg';

export const AccuracyRing = ({
  accuracy,
  label,
}: {
  accuracy: number;
  label: string;
}) => {
  const r = 22;
  const cx = 26;
  const cy = 26;
  const circ = 2 * Math.PI * r;
  const fill = (accuracy / 100) * circ;
  const color =
    accuracy >= 90
      ? CCColors.GameReview.AccuracyHigh
      : accuracy >= 75
      ? CCColors.GameReview.AccuracyMediumHigh
      : accuracy >= 60
      ? CCColors.GameReview.AccuracyMedium
      : CCColors.GameReview.AccuracyLow;

  return (
    <View style={{alignItems: 'center'}}>
      <View
        style={{
          width: 52,
          height: 52,
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 2,
        }}>
        <Svg width={52} height={52} viewBox="0 0 52 52">
          <Circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke={updateColorWithOpacity(CCColors.GameReview.Text, 0.08)}
            strokeWidth={3}
          />
          <Circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth={3}
            strokeDasharray={`${fill} ${circ}`}
            strokeLinecap="round"
            transform={`rotate(-90, ${cx}, ${cy})`}
          />
        </Svg>
        <CCText
          style={{
            position: 'absolute',
            fontSize: FontSizes[13],
            fontWeight: '800',
            color,
          }}>
          {accuracy.toFixed(0)}
        </CCText>
      </View>
      <CCText
        style={{
          fontSize: FontSizes[9],
          color: CCColors.GameReview.Muted,
          fontWeight: '500',
        }}>
        {label}
      </CCText>
    </View>
  );
};

export default AccuracyRing;
